import { render } from "./ExtranetMerchantForm.vue?vue&type=template&id=09b9e0ae&scoped=true"
import script from "./ExtranetMerchantForm.vue?vue&type=script&lang=js"
export * from "./ExtranetMerchantForm.vue?vue&type=script&lang=js"

import "./ExtranetMerchantForm.vue?vue&type=style&index=0&id=09b9e0ae&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09b9e0ae"]])

export default __exports__